export * from './dynamic-banner-config.interface';
export * from './dynamic-banner-content.interface';
export * from './dynamic-banner-style.interface';
